import type { LevelDefinition } from './Level.ts';

/**
 * Level 6 — arrival side.
 *
 * The first ball level taught that fluid carries the ball. This one teaches that *which
 * way the current arrives* decides which way the ball goes, which is the thing that makes
 * a ball level a puzzle rather than a stronger magnet.
 *
 * There are two ways down into the ball's room. The near one is straight along the line
 * from the reservoir to the goal, so a positive magnet on the goal takes it — and drops
 * the fluid on the far side of the ball, where the current pushes it away from where it
 * needs to go. Put the magnet on the ball instead and it is worse: the stream comes down
 * the near opening, crosses the room and shoves the ball into the opposite corner.
 *
 * The far opening is the answer, and reaching it means throwing the blob away from the
 * goal first. The current then comes up behind the ball and walks it home along the wall.
 *
 * Proven headlessly: the intended pair solves in 5.0s, an attractor on the goal settles at
 * 0%, an attractor on the ball ends with the ball at (798, 1397) — the far corner, 330wu
 * the wrong way — and no single magnet solves it from any of 270 grid positions.
 */
export const level06: LevelDefinition = {
  id: 'level06',
  name: 'Which way in',
  hint: 'Two ways down. The near one drops the fluid on the wrong side of the ball.',
  magnetsAvailable: 2,
  fluid: {
    amount: 380,
    source: { x: 340, y: 430 },
    radius: 44,
  },
  ball: { x: 700, y: 1385, radius: 40 },
  goal: { x: 470, y: 1385, radius: 105, type: 'ball' },
  walls: [
    // Arena.
    { type: 'segment', x1: 110, y1: 210, x2: 890, y2: 210, thickness: 26 },
    { type: 'segment', x1: 890, y1: 210, x2: 890, y2: 1450, thickness: 26 },
    { type: 'segment', x1: 890, y1: 1450, x2: 110, y2: 1450, thickness: 26 },
    { type: 'segment', x1: 110, y1: 1450, x2: 110, y2: 210, thickness: 26 },

    // The floor between the rooms. The near opening is the trap, the far one is the route.
    // Both are well over 90wu clear: below that a blob bridges the gap and plugs it.
    { type: 'segment', x1: 110, y1: 800, x2: 250, y2: 800, thickness: 26 },
    { type: 'segment', x1: 370, y1: 800, x2: 700, y2: 800, thickness: 26 },
  ],
};
